import createStandardI18nProvider from 'I18n/init/providers/createStandardI18nProvider';
const i18nProvider = createStandardI18nProvider();
let i18nSetupPromise = undefined;
const asyncSetupI18n = async options => {
  if (!i18nSetupPromise) {
    i18nSetupPromise = import( /* webpackChunkName: "whisper-i18n" */'./internal/i18n-setup').then(({
      setupI18n
    }) => {
      return setupI18n(i18nProvider, options);
    });
  }
  return i18nSetupPromise;
};
export const whisperI18n = {
  i18nProvider,
  setupI18n: asyncSetupI18n
};